module.exports = __webpack_public_path__ + "img/Basin Scope Logo.e936983d.webp";